import { useField } from 'formik'
import Textarea from './Textarea'

const FormikTextarea = ({ label, required, rows, ...props }) => {
  const [field, meta] = useField(props)

  return (
    <Textarea
      {...field}
      {...props}
      label={label}
      required={required}
      rows={rows}
      error={meta.touched && meta.error ? meta.error : undefined}
    />
  )
}

export default FormikTextarea

